module.exports = __webpack_public_path__ + "img/szdx.d7b81f18.png";